import { z } from "zod/v4";

export const activityPeriodSchema = z.enum(["day", "week", "month"]);

export const surfaceStatsSchema = z.object({
	club: z.number(),
	mobile: z.number(),
	unknown: z.number(),
});

export const activityRollupSchema = z.object({
	active_users: z.number(),
	by_surface: surfaceStatsSchema,
});

export const activityEventSchema = z.object({
	display_name: z.string(),
	id: z.string(),
	kind: z.string(),
	occurred_at: z.coerce.date(),
	subject: z.string().nullable().optional(),
	subject_id: z.string().nullable().optional(),
	user_id: z.string(),
});

export const activitySeriesPointSchema = z.object({
	date: z.string(),
	events: z.number(),
	users: z.number(),
});

export const activitySeriesSchema = z.object({
	points: z.array(activitySeriesPointSchema),
	range_days: z.number(),
});

export type ActivityPeriod = z.infer<typeof activityPeriodSchema>;
export type SurfaceStats = z.infer<typeof surfaceStatsSchema>;
export type ActivityRollup = z.infer<typeof activityRollupSchema>;
export type ActivityEvent = z.infer<typeof activityEventSchema>;
export type ActivitySeriesPoint = z.infer<typeof activitySeriesPointSchema>;
export type ActivitySeries = z.infer<typeof activitySeriesSchema>;
